var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-card',{staticClass:"ja-card is-loading",attrs:{"body-class":"ja-card-body"}},[_c('picture',{staticClass:"product-image"}),_vm._v(" "),_c('div',{staticClass:"product-detail"},[_c('div',{staticClass:"product-title"}),_vm._v(" "),_c('div',{staticClass:"product-summary"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }